var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeamImg3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 182,
  height: 182,
  viewBox: "0 0 182 182"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 91,
  r: 91,
  fill: "#7654fd",
  "data-name": "Ellipse 6"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#f0f0f0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.639 95.259a4.984 4.984 0 1 0 4.984-4.984 4.984 4.984 0 0 0-4.984 4.984",
  "data-name": "Path 316"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.482 106.856a8.545 8.545 0 0 0-12.843-3.574",
  "data-name": "Path 317"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.393 95.259a4.984 4.984 0 1 0 4.984-4.984 4.984 4.984 0 0 0-4.984 4.984",
  "data-name": "Path 318"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.519 106.856a8.545 8.545 0 0 1 12.843-3.574",
  "data-name": "Path 319"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.592 93.835A6.408 6.408 0 1 0 91 87.427a6.41 6.41 0 0 0-6.408 6.408",
  "data-name": "Path 320"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.953 107.362a11.518 11.518 0 0 0-17.9 0",
  "data-name": "Path 321"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.121 81.728H83.88V86l-7.121-4.272h-5.7V64.639h27.062Z",
  "data-name": "Path 322"
}), /*#__PURE__*/React.createElement("path", {
  d: "m79.607 70.335-2.848 2.848 2.848 2.848",
  "data-name": "Path 323"
}), /*#__PURE__*/React.createElement("path", {
  d: "m89.576 70.335 2.848 2.848-2.848 2.848",
  "data-name": "Path 324"
}), /*#__PURE__*/React.createElement("path", {
  d: "m85.304 70.335-1.424 5.7",
  "data-name": "Path 325"
}))));
export default SvgTeamImg3;